import {createSlice} from "@reduxjs/toolkit";


export const modalSlice = createSlice({
    name: 'modal',
    initialState: {
        modals: {},
        payloads: {},
        history: [],
    },
    reducers: {
        showModal(state, {payload}) {
            const {name, data} = payload
            state.history.push({...state.modals})
            state.payloads = {...state.payloads, [name]: data}
            state.modals = {...state.modals, [name]: true}
        },
        hideModal(state, {payload}) {
            delete state.payloads[payload]
            state.payloads = {...state.payloads}
            state.modals = {...state.modals, [payload]: false}
        },
        toggleModal(state, {payload}) {
            if (state.modals[payload]) state.history = []
            state.modals = {...state.modals, [payload]: !state.modals[payload]}
        },
        backModal(state) {
            const old = state.history.pop()
            state.modals = old ?? {}
        }
    }
})

export const {
    showModal,
    hideModal,
    toggleModal,
    backModal
} = modalSlice.actions
